// Attributter som tastatursnarveiene i appen (mimin/layout/
// KeyboardShortcuts) bruker for å finne elementer på siden.

/** På hovedknappen «Ny …» i sidehodet. «C» trykker på den. */
export const CREATE_SHORTCUT_ATTR = "data-shortcut-create";

/** På rader i lister. «J»/«K» flytter fokus mellom dem, Enter åpner. */
export const NAV_ROW_ATTR = "data-nav-row";
